module.exports = __webpack_public_path__ + "static/media/ic_arrow_slider_right.55c9e698.svg";